var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-wrapper"},[(_vm.showNumber)?_c('label',{style:({ textAlign: _vm.numberPosition })},[_vm._v(_vm._s(_vm.value)+"%")]):_vm._e(),_c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.value + '%' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }